import { render, staticRenderFns } from "./ReportUserView.vue?vue&type=template&id=070859b9"
import script from "./ReportUserView.vue?vue&type=script&lang=js"
export * from "./ReportUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports